// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"795":"a645b288","962":"a645b288"}[chunkId] + ".chunk.css";
};